// Dependencies
import Swal from "sweetalert2";
import { Button, Col, Form, Row } from "react-bootstrap";

// Hooks
import useForm from "../hooks/useForm";

// Services
import { getEmailText } from "../services/emailService";
import { Currency } from "../helpers";

export const GeneralForm = ({
  urlSection,
  isContactForm,
  isRentalCarForm,
  data,
}) => {
  let dataArray;
  let initialState = {
    emailAddress: "administracion@agenciamarzah.com",
    destinatarioCC: "",
    asunto:
      isContactForm === true
        ? `Han Solicitado información`
        : `Han Solicitado una cotización de renta de autos`,
    fullName: "",
    lastName: "",
    email: "",
    phone: "",
    comments: "",
    origin: "",
    destiny: "",
    adults: "",
    minors: "",
    nombreAuto: data?.name_auto,
    precio: data?.price,
    tituloAuto: data?.titulo,
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    lastName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    email: {
      test: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      message:
        "El correo solo puede contener letras, numeros, puntos y guiones.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit, resetForm } = useForm(
    initialState,
    validations
  );

  const submitForm = async () => {
    if (isContactForm === true) {
      dataArray = {
        destinatario: "administracion@agenciamarzah.com",
        destinatarioCC: formData.destinatarioCC,
        asunto: formData.asunto,
        mensaje: `Nombre completo: ${formData.fullName} ${
          isContactForm === true ? formData.lastName : ""
        } 
        \nTeléfono: ${formData.phone}
        \nCorreo: ${formData.email}
        \nComentario: ${formData.comments}`,
      };
    } else if (isRentalCarForm === true) {
      dataArray = {
        destinatario: "administracion@agenciamarzah.com",
        destinatarioCC: formData.destinatarioCC,
        asunto: formData.asunto,
        mensaje: ` 
        \nAuto: ${formData.nombreAuto}
        \nModelo: ${formData.tituloAuto}
        \nPrecio del auto: ${Currency(formData.precio)}
        \nNombre completo: ${formData.fullName + " " + formData.lastName}
        \nTeléfono: ${formData.phone}
        \nCorreo: ${formData.email}`,
      };
    }

    try {
      await getEmailText(dataArray);
      resetForm();
      Swal.fire({
        title: "Correo enviado exitosamente!",
        text: "El correo ha sido enviado, nos contactaremos con usted lo antes posible.",
        icon: "success",
      }).then((e) => {
        if (e.isConfirmed) {
          window.location.href = urlSection;
        }
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      Swal.fire({
        icon: "error",
        title: "Hubo un error al enviar el correo.",
        text: "Por favor intentelo mas tarde.",
      });
    }
  };
  return (
    <>
      <Form onSubmit={(e) => handleSubmit(e, submitForm)}>
        {isContactForm && (
          <>
            <Form.Group>
              <Form.Control
                placeholder="Nombre Completo"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="my-3">
              <Form.Control
                placeholder="Correo electrónico"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                placeholder="Teléfono"
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                as="textarea"
                rows={5}
                name="comments"
                placeholder="Mensaje"
                value={formData.comments}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Button
              className="my-3 w-100 text-light fw-semibold"
              style={{ background: "#3764ab" }}
              type="submit"
            >
              Enviar
            </Button>
          </>
        )}
        {isRentalCarForm && (
          <>
            <Form.Group>
              <Row>
                <Col lg={12} md={6}>
                  <Form.Label>Auto</Form.Label>
                  <Form.Control
                    name="nombreAuto"
                    value={formData.nombreAuto}
                    onChange={handleChange}
                    required
                    readOnly
                  />
                </Col>
                <Col lg={6} md={6}>
                  <Form.Label>Modelo</Form.Label>
                  <Form.Control
                    type="text"
                    name="titulo"
                    value={formData.tituloAuto}
                    onChange={handleChange}
                    required
                    readOnly
                  />
                </Col>
                <Col lg={6} md={6}>
                  <Form.Label>Precio del auto por día</Form.Label>
                  <Form.Control
                    type="text"
                    name="precio"
                    value={Currency(formData.precio)}
                    onChange={handleChange}
                    required
                    readOnly
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <Row>
                <Col lg={6} md={6}>
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col lg={6} md={6}>
                  <Form.Label>Apellido</Form.Label>
                  <Form.Control
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <Row>
                <Col lg={6} md={6}>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Col>

                <Col lg={6} md={6}>
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </Col>
              </Row>
            </Form.Group>
            <div className="d-flex mt-3 justify-content-end w-100">
              <Button style={{ background: "#3764ab" }} type="submit">
                Enviar
              </Button>
            </div>
          </>
        )}
      </Form>
    </>
  );
};
